// extracted by mini-css-extract-plugin
module.exports = {"caps":"LabelFontVariant_caps__S0Nlo","normal":"LabelFontVariant_normal__AnPq_","italic":"LabelFontVariant_italic__yyZcS","underline":"LabelFontVariant_underline__zBjQW"};